import React, { useState, useEffect } from "react";
import message from "../Image/message.png";
import { FaUserCircle } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import Signup from "./Signup";
import Login from "./Login";
import bitcoin from "../Image/bitcoin.png";
import logo from "../Image/Kling-Logo.png";
import { useNavigate } from "react-router-dom";

function Header({ setChatOpen }) {
  const [openSignup, setOpenSignup] = useState(false);
  const { openLogin, setOpenLogin, isAuth, setIsAuth } = useAuth();
  const { wallet, setWallet } = useAuth();
  const navigate = useNavigate();

  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  useEffect(() => {
    document.body.style.overflow = openSignup ? "hidden" : "auto";
  }, [openSignup]);

  useEffect(() => {
    document.body.style.overflow = openLogin ? "hidden" : "auto";
  }, [openLogin]);

  useEffect(() => {
    const storedAuth = localStorage.getItem("isAuth");

    if (storedAuth === "true") {
      setIsAuth(true);
    }
  }, []);
  console.log(isAuth);

  return (
    <>
      <div className="top-actions d-flex justify-content-between align-items-center">
        <div className="logo" onClick={() => navigate("/")}>
          <img src={logo} alt="logo" />
        </div>
        <div className="d-flex gap-3">
          {isAuth ? (
            <div className="d-flex justify-content-center align-items-center gap-3">
              <div className="wallet-inner d-flex align-items-center">
                <img src={bitcoin} alt="bitcoin" height={28} />
                <span>{wallet}</span>
              </div>
              <button
                className="login-btn"
                onClick={() => {
                  localStorage.removeItem("isAuth");
                  localStorage.removeItem("currentUser");
                  setIsAuth(false);
                }}
              >
                Log out
              </button>
              <div className="user-profile d-flex align-items-center gap-1">
                <FaUserCircle />
                <span className="user-name">
                  {currentUser?.email
                    ? currentUser.email.slice(0, 7) + "..."
                    : "User"}
                </span>
              </div>
            </div>
          ) : (
            <>
              <button className="login-btn" onClick={() => setOpenLogin(true)}>
                Login
              </button>

              <button
                className="signup-btn"
                onClick={() => setOpenSignup(true)}
              >
                Sign Up
              </button>

              <button
                className="chat-btn d-flex align-items-center"
                onClick={() => setChatOpen(true)}
              >
                <img src={message} alt="chat-icon" />
                Online Chat
              </button>
            </>
          )}
        </div>
      </div>

      {/* mobile-header */}
      <div className="mobile-header">
        <div className="mobile-inner">
          <img
            src={logo}
            alt="logo"
            className="mobile-logo"
            onClick={() => navigate("/")}
          />
          <div className="auth-buttons">
            {isAuth ? (
              <div className="d-flex align-items-center auth-buttons-inner">
                <div className="wallet-inner d-flex align-items-center">
                  <img src={bitcoin} alt="bitcoin" height={28} />
                  <span>{wallet}</span>
                </div>

                <button
                  className="login-btn"
                  onClick={() => {
                    localStorage.removeItem("isAuth");
                    localStorage.removeItem("currentUser");
                    setIsAuth(false);
                  }}
                >
                  Log out
                </button>

                <div className="user-profile d-flex align-items-center gap-1">
                  <FaUserCircle />
                  <span className="user-name">
                    {currentUser?.email
                      ? currentUser.email.slice(0, 7) + "..."
                      : "User"}
                  </span>
                </div>
              </div>
            ) : (
              <>
                <button
                  className="login-btn"
                  onClick={() => setOpenLogin(true)}
                >
                  Login
                </button>

                <button
                  className="signup-btn"
                  onClick={() => setOpenSignup(true)}
                >
                  Sign Up
                </button>
              </>
            )}
          </div>
        </div>
      </div>


      {openSignup && (
        <Signup onClose={() => setOpenSignup(false)} setIsAuth={setIsAuth} />
      )}
      {openLogin && (
        <Login onClose={() => setOpenLogin(false)} setIsAuth={setIsAuth} />
      )}
    </>
  );
}

export default Header;
